<template>
  <div class="result">
    <div
      v-if="loading"
      class="loading"
    >
      Loading...
    </div>

    <div
      v-if="error"
      class="error"
    >
      {{ error }}
    </div>

    <div
      v-if="result"
      class="content"
    >
      <p>{{ result.data.result }}</p>
    </div>
  </div>
</template>
<script>

import { entryService } from '@/_services';

export default {
  data() {
    return {
      loading: false,
      result: null,
      error: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage('stylelab.outlookAuthenticated');
        return;
      }
      this.error = null;
      this.result = null;
      this.loading = true;
      try {
        this.result = await entryService.createOutlookAuthToken(window.location.href);
        localStorage.setItem('stylelab.outlookAuthenticated', true);
      } catch (e) {
        this.error = e;
        localStorage.setItem('stylelab.outlookAuthenticated', false);
      } finally {
        this.loading = false;
        window.close();
      }
    },
  },
};
</script>
